import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaymentMethodRequest } from '../../../models/payment-method-request.interface';
import { PaypointService } from '../../../services/paypoint.service';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'kt-bridgepay-add-payment-dialog',
  templateUrl: './add-payment-dialog.component.html',
  styleUrls: ['./add-payment-dialog.component.scss'],
})
export class AddPaymentDialogComponent {
  activeTabIdx = 0;
  validationMessage: string | null = null;
  tabs = [];

  constructor(
    public dialogRef: MatDialogRef<AddPaymentDialogComponent>,
    private paypointService: PaypointService,
    private ngxPermissions: NgxPermissionsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (this.canAddCreditCards()) this.tabs.push('Credit Card');
    if (this.canAddACHBankTransfer()) this.tabs.push('ACH Bank transfer');
  }

  canAddCreditCards(): boolean {
    return !!this.ngxPermissions.getPermission('canAddCreditCards');
  }

  canAddACHBankTransfer(): boolean {
    return !!this.ngxPermissions.getPermission('canAddACHBankTransfer');
  }
  
  
  onPaymentAdded(event: any): void {
    const paymentMethodRequest: PaymentMethodRequest = {
      type: event.type,
      token_id: event.token.id,
      token_data: event.token,
      zip: event.zip,
      brand: event.brand,
      save_payment_method: event.savePaymentMethod,
      card_last4: event.cardLast4,
      alias: event.alias,
    };

    this.paypointService
      .createPaymentMethod(this.data.organization, this.data.customerId, paymentMethodRequest)
      .subscribe({
        next: () => {
          this.dialogRef.close();
        },
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  protected readonly close = close;
}
